import { defineComponent, ref } from 'vue';
import ProvinceFilterComponent from '@/components/provinceFilter/ProvinceFilter.vue';
import ProvinceTaskTableComponent from '@/components/provinceTaskTable/ProvinceTaskTable.vue';
import ProvinceTaskFormComponent from '@/components/provinceTaskTable/provinceTaskForm/ProvinceTaskForm.vue';

export default defineComponent({
  name: 'ImportantPage',
  components: {
    ProvinceFilterComponent,
    ProvinceTaskTableComponent,
    ProvinceTaskFormComponent,
  },
  setup: () => {
    const fiscalYearId = ref<number | null>();
    const provinceId = ref<number | null>();
    const selectedProvinceTaskId = ref<number | null>();
    const provinceTaskForm = ref<InstanceType<typeof ProvinceTaskFormComponent>>();

    const filterChange = (filter: { fiscalYearId: number; provinceId: number }) => {
      fiscalYearId.value = filter.fiscalYearId;
      provinceId.value = filter.provinceId;
    };

    const createClick = () => {
      provinceTaskForm.value?.show();
    };

    return {
      provinceTaskForm,
      fiscalYearId,
      provinceId,
      selectedProvinceTaskId,
      filterChange,
      createClick,
    };
  }
});

